import React, { Fragment } from 'react';
import parkinghub from '../../../../../images/parkinghubByWard.png';
import '../../driverFaq.css';
import PersonalVehicleAccess from './PersonalVehicleAccess';
import WalkingAccess from './WalkingAccess';

const ParkingHub = () => (
  <Fragment>
    <p style={{ color: 'grey' }}>ByWard Market - Downtown Ottawa</p>
    <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
      <li>
        <strong>41 George St, Ottawa, ON K1N 8W5</strong>
      </li>
      <li>
        <strong>Autzu EV: </strong>Level P4
      </li>
      <li>
        <strong>Closest LRT stations:</strong> Rideau Station (4-minute
        walk)
      </li>
    </ul>
    <br />
    <div style={{ width: '100%' }}>
      <img src={parkinghub} />
    </div>
    <br />
    <p>
      Autzu EV vehicles are parked on Level P4 of the Indigo Parking Lot at
      41 George St in the ByWard Market. The main entrance is opposite
      Hudson’s Bay on George St, and can also be accessed on York St by
      car.
    </p>
    <br />
    <p style={{ fontSize: '16px', fontWeight: 500 }}>
      How do I access the parking lot by car?
    </p>
    <PersonalVehicleAccess />
    <br />
    <p style={{ fontSize: '16px', fontWeight: 500 }}>
      How do I access the parking lot by walking?
    </p>
    <WalkingAccess />
  </Fragment>
);

export default ParkingHub;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/ParkingHub/Metcalfe/ParkingHub.js